<template>
  <v-container fluid>
    <selectVehiculo></selectVehiculo>
    <selectProducto></selectProducto>
    <v-layout row class="ps-2">
      <v-flex xs9>
        <v-container>
          <span class="primary--text title">Datos del cliente</span>
          <v-row no-gutters>
            <v-col cols="2">
              <span class="secondary--text caption">Clave :</span>
              <span class="primary--text caption">{{getActualCotization.Cliente}}</span>
            </v-col>
            <v-col cols="10">
              <span class="secondary--text caption">Interlocutor:</span>
              <span class="primary--text caption">{{getActualCotization.Interlocutor}}</span>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col cols="3">
              <span class="secondary--text caption">Ubicación :</span>
              <span class="primary--text caption">{{getDomicilioClienteSelected.Calle}}</span>
            </v-col>
            <v-col cols="2">
              <span class="secondary--text caption">Ciudad:</span>
              <span class="primary--text caption">{{getDomicilioClienteSelected.Localidad}}</span>
            </v-col>
            <v-col cols="1">
              <span class="secondary--text caption">CP:</span>
              <span class="primary--text caption">{{getDomicilioClienteSelected.codigoPostal}}</span>
            </v-col>
            <v-col cols="2">
              <span class="secondary--text caption">Centro :</span>
              <span
                class="primary--text caption"
              >{{getActualCotizacionInterlocutorDetalle.NotaSucursal}}</span>
            </v-col>
            <v-col cols="4">
              <span class="secondary--text caption">Envío:</span>
              <span
                class="primary--text caption"
              >{{getActualCotizacionInterlocutorDetalle.Observaciones01}}</span>
            </v-col>
          </v-row>
        </v-container>
      </v-flex>

      <v-flex xs3 class="pa-5">
        <v-text-field
          class="overline"
          x-small
          dense
          v-model="getActualCotization.NumeroReporte"
          :append-outer-icon="!getActualCotization.NumeroReporte ? 'search' : 'send'"
          label="Numero Reporte"
          type="text"
          @keyup.enter="searchReporte()"
          @click:append-outer="searchReporte()"
        ></v-text-field>
      </v-flex>
      <v-flex xs12 class="pt-3 pb-3 pr-2">
        <v-card elevation="10">
          <v-card-title>
            <span class="primary--text overline">
              Marca:
              {{getActualCotization.VehiculoMarca}}
            </span>
            <span class="primary--text overline pl-8">
              Modelo:
              {{getActualCotization.VehiculoModelo}}
            </span>
            <span class="primary--text overline pl-8">
              Año:
              {{getActualCotization.VehiculoYear}}
            </span>
            <span class="primary--text overline pl-8">
              Centro:
              {{getCotizadorConfigs.sucClaveSelected}}
            </span>
            <v-fab-transition>
              <v-btn
                v-show="!hidden"
                color="primary"
                absolute
                top
                right
                fab
                @click="agregarProducto"
              >
                <v-icon>fas fa-plus-square</v-icon>
              </v-btn>
            </v-fab-transition>
          </v-card-title>
          <v-data-table
            :headers="headers"
            :items="getActualCotizationPartidas"
            :footer-props="{
            itemsPerPageOptions: [300, 500, 1000], 
          }"
            class="elevation-1"
          >
            <template
              v-slot:item.PrecioUnitario="{ item }"
            >{{prefix="$" + (item.PrecioUnitario).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,") }}</template>
            <template
              v-slot:item.SubTotal="{ item }"
            >{{prefix="$" + (item.SubTotal).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,") }}</template>
            <template
              v-slot:item.UsuarioRegistra="{ item }"
            >{{item.UsuarioRegistra }} - {{item.UsuarioRegistraNombre}}</template>
            <template v-slot:item.FechaRegistro="{ item }">
              {{ item.FechaRegistro| moment("YYYY-MM-DD HH:mm") }}
              <v-tooltip top v-if="item.Comentarios">
                <template #activator="data">
                  <span v-on="data.on">
                    <v-icon small color="secondary" class="pl-1">fas fa-comment</v-icon>
                  </span>
                </template>
                <span>{{item.Comentarios}}</span>
              </v-tooltip>
            </template>
          </v-data-table>
          <v-card-actions></v-card-actions>
        </v-card>
      </v-flex>
      <v-flex xs3>
        <v-container>
          <span class="secondary--text subtitle-1">Información general</span>
          <v-row no-gutters>
            <v-col cols="6">
              <span class="secondary--text caption">Estatus:</span>
              <span class="primary--text caption">{{getActualCotization.EstadoTexto}}</span>
            </v-col>
            <v-col cols="6">
              <span class="secondary--text caption">Usuario:</span>
              <span class="primary--text caption">{{getActualCotization.UsuarioRegistraNombre}}</span>
            </v-col>
            <v-col cols="6">
              <span class="secondary--text caption">Cantidad Artículos:</span>
              <span class="primary--text caption">{{getActualCotization.TotalPiezas}}</span>
            </v-col>
            <v-col cols="6">
              <span class="secondary--text caption">Ganada:</span>
              <v-btn
                class="pl-3"
                text
                icon
                x-small
                color="primary"
                v-if="getActualCotization.Ganada"
              >
                <v-icon>fas fa-thumbs-up</v-icon>
              </v-btn>
              <v-btn class="pl-3" text icon x-small color="secondary" v-else>
                <v-icon>fas fa-thumbs-down</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import { mapGetters } from "vuex";
  import SelectVehiculo from "../cotizador/dialog_seleccionarVehiculo";
  import SelectProducto from "../cotizador/dialog_agregarProducto";
  export default {
    data: () => ({
      IdReporte: "",
      listaClientes: ["0001001662", "0001001440", "0001002011", "0001001315"],
      loadingEnable: true,
      hidden: false,
      seleccionaVehiculoEnabled: false,
      seleccionaProductoEnabled: false,
      clienteSelected: "",
      interlocutorSelected: "",
      options: {
        sortBy: ["Pedido.IdPedidoCliente"],
        sortDesc: [false],
        page: 1,
        itemsPerPage: 300
      },
      headers: [
        {
          text: "Producto",
          value: "ProClave",
          align: "left"
        },
        {
          text: "Cant",
          align: "left",
          value: "CantidadPiezas"
        },
        {
          text: "Descripcion",
          value: "ProDescripcion",
          align: "left"
        },

        {
          text: "Precio",
          align: "left",
          value: "PrecioUnitario",
          sortable: false
        },
        {
          text: "Sucursal",
          align: "left",
          value: "SucClave",
          sortable: false
        },
        {
          text: "Registrado",
          value: "UsuarioRegistra",
          align: "left",

          sortable: false
        },
        {
          text: "Fecha",
          value: "FechaRegistro",
          align: "left",

          sortable: false
        }
      ]
    }),
    computed: mapGetters([
      "getListaProductos",
      "isCliente",
      "listaPrecios",
      "getInterlocutores",
      "getvehiculoSeleccionado",
      "getActualCotization",
      "getActualCotizationPartidas",
      "getCotizadorConfigs",
      "getActualCotizacionInterlocutorDetalle",
      "getDomicilioClienteSelected",
      "getListaTemporalProductos"
    ]),
    watch: {},
    created() {
      let self = this;
      if (self.$route.params.id && self.$route.params.id != "nueva") {
        //console.log("Se recibe número de reporte...");
        self.getActualCotization.NumeroReporte = self.$route.params.id;
        // console.log(self.getActualCotization.NumeroReporte);
        // console.log("Ejecutando searchReporte...");
        self.searchReporte();
        // self.IdReporte = self.$route.params.id;
        // console.log(self.IdReporte);
      } else {
        console.log("No se recibe parámetro válido... Se registrará nueva");
        console.log("Borrando cliente...");
        this.getActualCotization.Cliente = "";
        this.getActualCotization.Interlocutor = "";
        this.getActualCotization.VehiculoMarca = "";
        this.getActualCotization.VehiculoModelo = "";
        this.getActualCotization.VehiculoYear = "";
        this.getDomicilioClienteSelected.Calle = "";
        this.getDomicilioClienteSelected.Localidad = "";
        this.getDomicilioClienteSelected.codigoPostal = "";
        this.getActualCotizacionInterlocutorDetalle.NotaSucursal = "";
        this.getActualCotizacionInterlocutorDetalle.Observaciones01 = "";
        this.getActualCotization.TotalPiezas = 0;
        this.getActualCotization.UsuarioRegistraNombre = "";
        this.$store.commit("updateActualCotizationPartidas", []);
        this.getActualCotization.NumeroReporte = "";
      }
    },
    mounted() {},
    methods: {
      agregarProducto() {
        // console.log("Agregando nuevo producto...");
        this.getCotizadorConfigs.dialogAgregarProductoEnabled = true;
        this.$store.commit("updateListaProductosTemporal", []);
      },
      searchReporte() {
        //console.log("Searching " + this.getActualCotization.NumeroReporte);
        this.$store
          .dispatch("getCotizacionData", this.getActualCotization.NumeroReporte)
          .then(e => {
            if (e) {
              // console.log(
              //   "Datos obtenidos de manera correcta... Centro del Interlocutor:"
              // );
              // console.log(this.getActualCotizacionInterlocutorDetalle.SucClave);
            } else {
              console.log(
                `No se encontró información para: ${this.getActualCotization.NumeroReporte}`
              );
              console.log("Borrando cliente...");
              this.getActualCotization.Cliente = "";
              this.getActualCotization.Interlocutor = "";
              this.getActualCotization.VehiculoMarca = "";
              this.getActualCotization.VehiculoModelo = "";
              this.getActualCotization.VehiculoYear = "";
              this.getDomicilioClienteSelected.Calle = "";
              this.getDomicilioClienteSelected.Localidad = "";
              this.getDomicilioClienteSelected.codigoPostal = "";
              this.getActualCotizacionInterlocutorDetalle.NotaSucursal = "";
              this.getActualCotizacionInterlocutorDetalle.Observaciones01 = "";
              this.getActualCotization.TotalPiezas = 0;
              this.getActualCotization.UsuarioRegistraNombre = "";
              this.$store.commit("updateActualCotizationPartidas", []);
              this.getCotizadorConfigs.sucClaveSelected = "CDG1";
            }
          })
          .catch(e => {
            console.log("Error al procesar la información...");
            console.log(e);
          });
      },
      addProduct() {
        console.log("Adding Producto");
      },
      //PENDING Muy buen concatenador
      textConcatena: item =>
        `${item.Consignatario} - ${item.Clave} - ${item.codigoPostal} - ${item.Calle}`
    },
    components: { SelectVehiculo, SelectProducto }
  };
</script>





<style scoped lang="scss">
@import "../../../variables.scss";

.example {
  color: green;
  font-size: $font-size-root;
}
</style>